<template>
<div style="display:inline-block">
   <div :class="show?'pos':''" >
    <div  v-show="show" class="pos" @click.self="hide">
      <img id="scale" @click.self="hide" :src="src" alt="" ref="full">
    </div>
    <b-button size='sm' variant='secondary' @click="shows" v-show="!show"><i class="zmdi zmdi-help"></i> 范例</b-button>
   </div>
  </div>
</template>
<style lang="scss" scoped>
.pos{
    width: 100%;
    height: 100%;
    transition: all ease .2s;
    position: fixed;
    top: 0;
    left:0;
    right: 0;
    bottom:0;
    margin:auto;
    background: rgba(0,0,0,.6);
    z-index: 999999999999;
    overflow: scroll;
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    padding-top: 20px;
}
img{
  width: 100%;
}
#scale{
  margin: 0 auto;
}
</style>

<script>
export default {
  name: 'carousel-extend',
  data () {
    return {
      show: false
    }
  },
  props: {
    width: {
      type: Number,
      default: 992
    },
    height: {
      type: Number,
      default: 400
    },
    src: {
      type: String,
      default: ''
    }
  },
  methods: {
    shows () {
      // console.log(this.show)
      // this.onSlideEnd()
      // this.slide = index
      this.show = true
      // let vm = this
      // let i = 0.4
      // let scale = 0
      // window.onmousewheel = function (e) {
      //   e.preventDefault()
      // if (e.wheelDelta > 0) {
      //   i += 0.1
      // } else if (e.wheelDelta < 0) {
      //   if (i <= 0.5) {
      //     i = 0.5
      //   }
      //   i -= 0.1
      // }
      // scale = i
      // // console.log(i)
      // vm.$refs.full.style.cssText = `transform:scale(${scale}, ${scale})`
      // }
    },
    hide () {
      window.onmousewheel = null
      this.show = false
    }
  },
  mounted () {
    // var vm = this
    this.$refs.full.style.width = this.width + 'px'
    // this.$refs.full.style.height = this.height + 'px'
  }
}
</script>


// WEBPACK FOOTER //
// src/components-base/components-custom/scale/scale.vue